export const ENV = process.env.REACT_APP_ENV ?? 'dev'

export const SITE_URL =
  process.env.REACT_APP_SITE_URL ?? 'https://land.nftp.k8s.jelvix.dev'
